<template>
    <div class="tab-content-container">
        <Row>
            <Col flex="1">
            <Card class="card-container" dis-hover>
                <div slot="title" class="card-title">{{ getTranslation('k086') }}</div>
                <Row class="limit-line table-row-odd" type="flex" >
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('b006') }}
                        </Col>
                        <Col flex="2">
                        <Select :transfer="true" v-model="selectLibrary.ProgramId" class="input-field"
                            @on-change="libraryChange()" :placeholder="getTranslation('m034')"
                            :not-found-text="getTranslation('b038')">
                            <Option v-for="item in allLibrary" :value="item.id" :key="item.id">{{ item.ProgramId }}</Option>
                        </Select>
                        </Col>
                    </Row>
                    </Col>
                    <Col flex="2">
                    </Col>
                </Row>
                <Row class="limit-line" type="flex">
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k106') }}
                        </Col>
                        <Col flex="2"><Select :transfer="true" v-model="selectLibrary.PssWeld1" class="input-field"
                            :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                            <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                        </Select></Col>
                    </Row>
                    </Col>
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k108') }}
                        </Col>
                        <Col flex="2"><Input type="number" v-model="selectLibrary.PssWeld3"
                            class="input-field" />&nbsp;%</Col>
                    </Row>
                    </Col>
                    <Col flex="1">
                        <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k109') }}</Col>
                        <Col flex="2"><Input type="number" v-model="selectLibrary.PssKeep" class="input-field" />&nbsp;%
                        </Col>
                    </Row>
                    </Col>
                </Row>
                <Row class="limit-line table-row-odd" type="flex">
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k107') }}</Col>
                        <Col flex="2"><Input type="number" v-model="selectLibrary.PssCold2"
                            class="input-field" />&nbsp;%</Col>
                    </Row>
                    </Col>
                    <Col flex="1">                    
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('r144') }}
                        </Col>
                        <Col flex="2"><Input type="number" :value="programPower(selectLibrary)" disabled
                            class="input-field" /></Col>
                    </Row>
                    </Col>
                    <Col flex="1">
                   
                    </Col>
                </Row>
            </Card>
            <Row>
                <Col>
                <Button type="primary" size="small" con="md-download" @click.native="download()">{{ getTranslation('k023')
                    }}</Button>&nbsp;
                </Col>
            </Row>
            </Col>
        </Row>
    </div>
</template>
<script>
import { API_URL } from '@/constants/const';
import axios from 'axios';
import { Card, Row, Col, Button, Select, Option, Input } from "view-design"
import { postJsError } from '@/util/util.js'
import { mapGetters } from 'vuex'
export default {
    name: 'UipSetting', // 组件名称
    components: {
        Card, Row, Col, Button, Select, Option, Input
    },
    props: {
        kind: {
            type: Number,
            default: 803
        },
        programSize: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            info: {},
            allLibrary: [],
            selectLibrary: {},
            mac: 0
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        SwitchList() {
            return [
                this.getTranslation("k048"),
                this.getTranslation("k049"),
            ]
        },
    },
    watch: {

    },

    created() {
        this.init();
    },
    methods: {
        init() {
            this.mac = this.$route.query.mac
            this.allLibrary = this.createLibrary(this.programSize);
            if (this.allLibrary.length > 0) {
                this.selectLibrary.ProgramId = 0;
                this.libraryChange();
            }
        },
        createLibrary(size) {
            let rs = []
            for (var i = 0; i < size; i++) {
                rs.push({ "id": i, "ProgramId": i })
            }
            return rs;
        },
        libraryChange() {
            if (this.selectLibrary.ProgramId > -1) {
                let url = API_URL["programInfo"];
                let params = {
                    mac: this.mac,
                    mode: 2,
                    id: this.selectLibrary.ProgramId
                };

                axios.get(url, {
                    params: params
                })
                    .then(res => {
                        if (res && res.data && res.data.code == 200) {
                            this.selectLibrary = { ...res.data.data };
                            //this.$Message.success(res.data.msg);
                        } else if (res && res.data && res.data.msg) {
                            this.$Message.error(res.data.msg);
                        }
                    })
                    .catch((err) => {
                        postJsError(err)
                        this.$Message.error(this.getTranslation('c001'));
                    })
            } else {
                // 如果没有选中任何项，清空selectLibrary数据
                this.selectLibrary = { ...this.originLibrary };
            }

        },
        download() {
            let url = API_URL["systemUipSettingDownload"] + '?mac=' + this.mac + "&program_id=" + this.selectLibrary.ProgramId
            let params = new FormData();
            this.selectLibrary && Object.keys(this.selectLibrary).forEach(key => {
                params.append(key, this.selectLibrary[key]);
            });
            axios.post(url,
                params
            )
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.$Message.success(res.data.msg);
                    } else if (res && res.data && res.data.msg) {
                        this.$Modal.error({
                            width: 50,
                            title: this.getTranslation("r098"),
                            content: res.data.msg.replace(/\n/g, '<br>'),
                            okText: this.getTranslation("m063"),
                            });
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        programPower(selectLibrary){
            let highBit = selectLibrary.PssPostWeld || 0;
            let lowBit = selectLibrary.PssCold3 || 0;
            return highBit * 65536  + lowBit;
        }

    },

}
</script>

<style scoped>
@import url('../../../assets/style/list.css');
@import url('../../../assets/style/tab.css');
</style>